import * as React from 'react'

function SvgBin(props) {
  return (
    <svg
      width="1rem"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.496 3.576l-.353-1.059a.985.985 0 00-.936-.674H9.238V.876A.877.877 0 008.362 0H5.643a.877.877 0 00-.876.876v.967H1.798a.985.985 0 00-.935.674l-.354 1.06a.795.795 0 00.752 1.043h.37l.812 10.05c.06.746.693 1.33 1.441 1.33h6.402c.748 0 1.38-.584 1.44-1.33l.814-10.05h.204a.795.795 0 00.752-1.044zM5.705.937H8.3v.906H5.705V.938zm5.088 13.657a.511.511 0 01-.507.469H3.884a.511.511 0 01-.506-.469L2.57 4.62H11.6l-.806 9.974zM1.463 3.682l.289-.868a.049.049 0 01.046-.033h10.41c.02 0 .039.013.046.033l.29.868H1.461z"
        fill="#fff"
        fillOpacity={0.8}
      />
    </svg>
  )
}

export default SvgBin
